import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import ValuesOne from "../components/values/Values_1";
import BlockPrincipal from "../components/block/Block_4";
import BlockSecondary from "../components/block/Block_3";

function About() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="About">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="About"
          Subheader="About"
          bgimg={rpdata?.gallery?.length > 0 ? rpdata?.gallery?.[10] : rpdata?.stock?.[0]}
        />
        <BlockPrincipal
          title={'a little about us'}
          subtitle2={rpdata?.dbSlogan?.[3]?.slogan}
          text={rpdata?.dbAbout?.[0]?.text}
          image1={rpdata?.gallery?.length > 1 ? rpdata?.gallery?.[11] : rpdata?.stock?.[1]}
          image2={rpdata?.gallery?.length > 2 ? rpdata?.gallery?.[12] : rpdata?.stock?.[2]}
          image3={rpdata?.gallery?.length > 3 ? rpdata?.gallery?.[13] : rpdata?.stock?.[3]}
          listAbout={true}
        />
        <ValuesOne
          image1={rpdata?.gallery?.length > 4 ? rpdata?.gallery?.[14] : rpdata?.stock?.[4]}
        />

        <BlockSecondary
          title={rpdata?.dbSlogan?.[2]?.slogan}
          text={rpdata?.dbAbout?.[1]?.text}
          image={rpdata?.gallery?.length > 5 ? rpdata?.gallery?.[15] : rpdata?.stock?.[5]}
        />
      </div>
    </BaseLayout>
  );
}

export default About;
